import { useInView, useMotionValue, useSpring } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export function CountUpNumber({ value }: { value: string }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  const match = value.match(/^(\d+)(.*)$/);
  const number = Number(match?.[1] ?? 0);
  const suffix = match?.[2] ?? "";

  const motionValue = useMotionValue(0);
  const springValue = useSpring(motionValue, {
    duration: 1800,
    bounce: 0,
  });

  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (isInView) {
      motionValue.set(number);
    }
  }, [isInView, motionValue, number]);

  useEffect(() => {
    return springValue.on("change", (latest) => {
      setDisplay(Math.round(latest));
    });
  }, [springValue]);

  return (
    <span ref={ref} className="inline-flex items-baseline gap-1">
      <span>{display}</span>
      {suffix && <span className="text-[0.55em] leading-none">{suffix}</span>}
    </span>
  );
}
